module.exports = __webpack_public_path__ + "static/img/aquaman2_esp.817ce11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/aquaman2_esp.png
// module id = +2ar
// module chunks = 1